import { Component } from '@angular/core';

@Component({
  selector: 't-workflow-studio-icon',
  standalone: true,
  imports: [],
  templateUrl: './workflow-studio-icon.component.html',
  styleUrl: './workflow-studio-icon.component.css',
})
export class WorkflowStudioIconComponent {}
